import { setPageName } from "../redux/actions";
import { useDispatch } from "react-redux";
import { goPage } from "../system/coords";

// Images
const ArrowIcon = "/assets/images/arrow.svg";

const BBCRD = "/assets/images/clients/bbc-rd.svg";
const BritishAirways = "/assets/images/clients/british-airways.png";
const CyberDiscovery = "/assets/images/clients/cyber-discovery.png";
const CyberStart = "/assets/images/clients/cyberstart.svg";
const DCMS = "/assets/images/clients/dcms.png";
const Ecotricity = "/assets/images/clients/ecotrcitity.svg";
const HMGovernment = "/assets/images/clients/hm-government.png";
const KingstonCommunications = "/assets/images/clients/kingston-communications.svg";
const NationalCyberScholarshipFoundation = "/assets/images/clients/national-cyber-scholarship-foundation.png";
const NationalCyberSecurityStrategy = "/assets/images/clients/national-cyber-security-strategy.png";
const Northgate = "/assets/images/clients/northgate.png";
const PraxisCriticalSystems = "/assets/images/clients/praxis-critical-systems.png";
const Reebok = "/assets/images/clients/reebok.png";
const SANS = "/assets/images/clients/sans.svg";
const USAGovernment = "/assets/images/clients/usa-government.png";

const TT = (elem, tgt, vis) => {
  let left = 0;
  let leftShift = 0;
  let topShift = 0;
  if (elem) {
    setTimeout(() => {
      left = elem.getBoundingClientRect().left;
      leftShift = Math.round(
        (elem.getBoundingClientRect().width - document.querySelector("#" + tgt).getBoundingClientRect().width) / 2,
      );
      document.querySelector("#" + tgt).style.left = Math.round(left + leftShift) + "px";
      topShift = elem.getBoundingClientRect().top - 50;
      document.querySelector("#" + tgt).style.top = Math.round(topShift) + "px";
    }, 0);
    const alt = elem.alt;
    document.querySelector("#" + tgt).innerHTML = alt;
  }
  document.querySelector("#" + tgt).style.opacity = "show" === vis ? "1" : "0";
};

const ClientsContent = () => {
  const numYears = new Date().getFullYear() - 1999;
  const dispatch = useDispatch();

  return (
    <>
      <div className="Clients center full-height">
        <p>Many web app, cyber security and data solutions have been built over {numYears} years.</p>
        <p>During that time around 450 projects have been built for over 300 clients, including:</p>
        <div className="client-logos">
          <div id="TTClient" className="tooltip"></div>
          <img
            src={BBCRD}
            alt="BBC R&D"
            className="client-logo"
            onMouseOver={evt => {
              TT(evt.target, "TTClient", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTClient", "hide");
            }}
          />
          <img
            src={BritishAirways}
            alt="British Airways"
            className="client-logo"
            onMouseOver={evt => {
              TT(evt.target, "TTClient", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTClient", "hide");
            }}
          />
          <img
            src={CyberDiscovery}
            alt="Cyber Discovery"
            className="client-logo"
            onMouseOver={evt => {
              TT(evt.target, "TTClient", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTClient", "hide");
            }}
          />
          <img
            src={CyberStart}
            alt="CyberStart"
            className="client-logo"
            onMouseOver={evt => {
              TT(evt.target, "TTClient", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTClient", "hide");
            }}
          />
          <img
            src={DCMS}
            alt="Department for Digital, Culture, Media and Sport (DCMS)"
            className="client-logo"
            style={{ height: "70px" }}
            onMouseOver={evt => {
              TT(evt.target, "TTClient", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTClient", "hide");
            }}
          />
          <img
            src={Ecotricity}
            alt="Ecotricity"
            className="client-logo"
            onMouseOver={evt => {
              TT(evt.target, "TTClient", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTClient", "hide");
            }}
          />
          <img
            src={HMGovernment}
            alt="HM Government"
            className="client-logo"
            onMouseOver={evt => {
              TT(evt.target, "TTClient", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTClient", "hide");
            }}
          />
          <img
            src={KingstonCommunications}
            alt="Kingston Communications"
            className="client-logo"
            onMouseOver={evt => {
              TT(evt.target, "TTClient", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTClient", "hide");
            }}
          />
          <img
            src={NationalCyberScholarshipFoundation}
            alt="National Cyber Scholarship Foundation"
            className="client-logo"
            onMouseOver={evt => {
              TT(evt.target, "TTClient", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTClient", "hide");
            }}
          />
          <img
            src={NationalCyberSecurityStrategy}
            alt="National Cyber Security Strategy"
            className="client-logo"
            onMouseOver={evt => {
              TT(evt.target, "TTClient", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTClient", "hide");
            }}
          />
          <img
            src={Northgate}
            alt="Northgate"
            className="client-logo"
            style={{ height: "auto" }}
            onMouseOver={evt => {
              TT(evt.target, "TTClient", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTClient", "hide");
            }}
          />
          <img
            src={PraxisCriticalSystems}
            alt="Praxis Critical Systems"
            className="client-logo"
            onMouseOver={evt => {
              TT(evt.target, "TTClient", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTClient", "hide");
            }}
          />
          <img
            src={Reebok}
            alt="Reebook"
            className="client-logo"
            onMouseOver={evt => {
              TT(evt.target, "TTClient", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTClient", "hide");
            }}
          />
          <img
            src={SANS}
            alt="SANS"
            className="client-logo"
            onMouseOver={evt => {
              TT(evt.target, "TTClient", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTClient", "hide");
            }}
          />
          <img
            src={USAGovernment}
            alt="USA Government"
            className="client-logo"
            onMouseOver={evt => {
              TT(evt.target, "TTClient", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTClient", "hide");
            }}
          />
        </div>
        <p>
          ...and many more, from SME's to multinational corporations, across a wide range of industries and sectors.
        </p>
      </div>
      <img
        src={ArrowIcon}
        className="Arrow-icon Arrow-Clients"
        alt="Go to next page"
        onClick={() => {
          goPage("Tech");
          dispatch(setPageName("Tech"));
        }}
      />
    </>
  );
};

export default ClientsContent;
